<mat-form-field appearance="fill">
    <mat-select #select [(value)]="value" class="" (openedChange)="selectionChanged($event)">
        <mat-option *ngIf="clearOption">-- None --</mat-option>
        <mat-option *ngFor="let option of options" [value]="option.Value">{{option.Text}}</mat-option>
    </mat-select>
</mat-form-field>